import { User } from '@auth0/auth0-react';
import { proxy } from 'valtio';

interface UserState {
  user: User | null;
}

const userState = proxy<UserState>({
  user: null,
});

export const setUser = (user: User | null | undefined) => {
  userState.user = user ?? null;
};

export const getCurrentUser = () => userState.user;
